/* eslint-disable react/jsx-newline */
/* eslint-disable react/jsx-no-literals */
/* eslint-disable max-len */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable max-lines */
import FuelType from '^enums/model/FuelType';
import ColorMaterialType from '^enums/model/ColorMaterialType';
import GearType from '^enums/model/GearType';
import ColorType from '^enums/model/ColorType';
import EmissionLabel from '^common/EmissionLabel';
import TTexts from '^types/common/TTexts';

const SE: TTexts = {
  units: {
    kilometers: 'km',
    consumption: 'l/100km',
    electricConsumption: 'Wh/km',
    emission: 'g/km',
    batteryCapacity: 'kWh',
  },
  moneyUnits: {
    default: 'kr.',
    pricePerMonth: 'kr/mån',
  },
  header: {
    title: 'priser och specifikationer',
  },
  steps: {
    campaignVariants: {
      title: 'Kampanjmodeller',
    },
    variants: {
      title: 'Varianter',
      legend: {
        campaignVariant: 'Kampanjmodeller',
      },
      disclaimer: (url: string): string => `Ekstra kilometer kan tilkøbes på alle modeller. Kontakt venligst din forhandler som kan give dig et tilbud der passer til dit behov. Eller klik selv ind på vores Online beregner for Privatleasing på ${url}`,
    },
    technicalParameters: {
      title: 'Tekniska specifikationer',
      categories: {
        engine: 'Motor',
        battery: 'Batteri',
        fuelConsumption: 'Bränsleförbrukning (km/l- WLTP-standard)',
        performance: 'Prestanda',
        dimensions: 'Mått',
        dimensionsExterior: 'Mått, exteriör',
        dimensionsInterior: 'Mått, interiör',
        volumes: 'Volym',
        weights: 'Vikt',
        weightsAndTrackVolume: 'Vikt & Bagagerumsvolym',
        brakes: 'Bromsar',
      },
      specifications: {
        cylindersVolume: (
          <>
            Cylindervolym (cm<sup>3</sup>)
          </>
        ),
        cylindersAmount: 'Cylindrar',
        maxPowerCee: 'Max. effekt CEE KW',
        maxHorsepowerCombinedCombustion: 'Max. Effekt kombinerad förbränningsmotor',
        maxHorsepowerElectricEngine: 'Max. Effekt elmotor HK fram/bak',
        maxHorsepowerAtRevolutionsPerMinute: 'Max. effekt HK vid varv/min',
        maxTorque: 'Max. vridmoment Nm',
        hasStartStop: 'Start & Stop',
        batteryCapacity: 'Kapacitet (kWh)',
        chargingCable: 'Laddkabel',
        chargingTimeAlternatingCurrent: 'Laddtid AC 11 kW (0-100 %)',
        chargingTimeDirectCurrent: 'Laddtid DC 100 kW (0-80 %)',
        energyConsumption: 'Energiförbrukning (Wh/km)',
        batteryMaxPower: 'Maximal prestanda (kW)',
        onBoardCharger: 'OBC (Ombordladdare)',
        plugType: 'Stickkontakt',
        batteryType: 'Typ',
        tractionWheels: 'Drivande hjul',
        drivingRange: 'Räckvidd (km)',
        mixedDrivingConsumption: 'Blandad körning (km/l)',
        cityDrivingConsumption: 'Stadskörning (km/l)',
        highwayDrivingConsumption: 'Landsvägskörning (km/l)',
        co2Emission: (
          <>
            <EmissionLabel />-utsläpp g/km
          </>
        ),
        acceleration: 'Acceleration från 0-100 km/t (sek)',
        maxSpeed: 'Topphastighet (km/t)',
        heightWithRoofRails: 'Höjd med takräcken (mm)',
        heightWithoutRoofRails: 'Höjd utan takräcken (mm)',
        height: 'Höjd (mm)',
        length: 'Längd (mm)',
        tireSize: 'Standarddäckdimension',
        wheelbase: 'Hjulbas (mm)',
        exteriorWidthWithMirrors: 'Bredd (exkl. sidospeglar) (mm)',
        exteriorWidthWithoutMirrors: 'Bredd (inkl. sidospeglar) (mm)',
        frontSeatsLength: 'Justeringslängd framsäten (mm)',
        frontInteriorWidth: 'Bredd, fram (mm)',
        rearInteriorWidth: 'Bredd, bak (mm)',
        fuelTankCapacity: 'Bränsletankens kapacitet (liter)',
        trunkVolumeWithRearSeatsDown: 'Bagagerumsvolym med baksäten nedfällda (liter)',
        trunkVolumeWithRearSeatsUp: 'Bagagerumsvolym med baksäten uppfällda (liter)',
        maxRoofLoad: 'Max. Taklast (kg)',
        maxWeightOfTrailerCoupling: 'Totalvikt släpvagnskoppling',
        readyWeight: 'Vikt körklart skick (kg)',
        totalWeight: 'Totalvikt (kg)',
        truckWeight: 'Tågvikt (kg)',
        approvedPayload: 'Typgodkänd nyttolast',
        approvedTrailerWeightWithBrakes: 'Typgodkänd släpvagnsvikt med bromsar',
        approvedTrailerWeightWithoutBrakes: 'Typgodkänd släpvagnsvikt utan bromsar',
        maxTrailerWeightWithBrakes: 'Max.Släpvagnsvikt med bromsar',
        maxTrailerWeightWithoutBrakes: 'Max.Släpvagnsvikt utan bromsar',
        frontBrakesType: 'Frambromsar',
        rearBrakesType: 'Bakbromsar',
      },
    },
    colors: {
      title: 'Färger',
      materialType: {
        [ColorMaterialType.Metallic]: 'Metallic-lack',
        [ColorMaterialType.Standard]: 'Standardlack',
        [ColorMaterialType.Special]: 'Speciallack',
        [ColorMaterialType.Pastel]: 'Pastel',
      },
    },
    trims: {
      title: 'Utrustning',
      highlighted: 'Utvald utrustning',
    },
    chargingSubscriptions: {
      title: 'Laddningsabonnemang',
      subscription: 'Abonnemang',
      installation: 'Installation',
    },
    accessories: {
      title: 'Tillbehör',
      price: 'Pris',
    },
    interiors: {
      /**
       * TODO
       * Request translation
       */
      title: 'Interiör',
    },
  },
  common: {
    tableLegends: {
      included: 'Inklusive',
      notPossible: 'Ej tillgänglig',
      optional: 'Optional',
    },
    errorPage: {
      title: 'Någonting gick fel',
      description: 'Vänligen, försök igen senare',
    },
    variantPrice: {
      savedAmount: 'Spara',
    },
    gearTypes: {
      [GearType.Automatic]: 'Automatisk',
      [GearType.Manual]: 'Manuell',
    },
    colorTypes: {
      [ColorType.Base]: 'Färg',
      [ColorType.Roof]: 'Takfärg',
      [ColorType.ColorPack]: 'Färgpaket',
    },
    fuelTypes: {
      [FuelType.Diesel]: 'Diesel',
      [FuelType.Electric]: 'Elektrisk',
      [FuelType.Hybrid]: 'Plug-in hybrid',
      [FuelType.Petrol]: 'Bensin',
      [FuelType.MildHybrid]: 'Hybrid',
    },
    noVariants: {
      title: 'Priser kan inte hämtas',
      description: 'Kontakta din närmaste återförsäljare för mer information.',
    },
    months: 'months',
  },
  tableFields: {
    price: 'Pris',
    fuelType: 'Bränsle',
    engine: 'Motor',
    horsePowers: 'Hästkrafter',
    gearBox: 'Växellåda',
    consumption: 'Förbrukning',
    // No need for energyClass ownerTax as we don't show them for SE locale
    energyClass: '',
    ownerTax: '',
    emission: <EmissionLabel />,
    batteryCapacity: 'Batteri',
    drivingRange: 'Räckvidd',
    period: 'Løbetid',
    downPayment: 'Udbetaling',
    kmPerYear: 'Kilometer pr. år',
    monthlyPrice: 'Månedlig ydelse',
    totalMinimumPrice: 'Betaling i bindingsperioden',
    totalPrice: 'Betaling i perioden',
  },
  controls: {
    configureCar: 'Konfigurera din bil',
    bookCarOnline: 'Köpa bil online',
    downloadPriceList: 'Ladda ned hela prislistan',
  },
};

export default SE;
